import React from 'react';
import { Category } from "models/Questionnaire"
import { Container, Row, Col } from "react-bootstrap"

interface CategoryDescriptionProps {
	category: Category;
	children: any;
}


const CategoryDescriptionView = (props: CategoryDescriptionProps) => {
	return (
		<Container className='pt-4'>
			<h1 className='mb-4 text-center'>{props.category.answertitle}</h1>
			<Row className='justify-content-center category-description'>
				<Col xs='auto' sm='8' className='text-center mb-2'><p>{props.category.description}</p></Col>
			</Row>
			{props.children}
		</Container>
	)
}

export default CategoryDescriptionView;